<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">Confirm</button>
</mat-dialog-actions>